import { instance } from '@/services/avik-api-gateway'
export function activateUser(user_id: string) {
  return instance.patch(`/iam/user/${user_id}/undelete`)
}
